export const UPDATE_RETIREMENT_AGE_DATA = 'UPDATE_RETIREMENT_AGE_DATA';
export const MODEL_RETIREMENT_AGE_SCENARIO = 'MODEL_RETIREMENT_AGE_SCENARIO';
export const UPDATE_RETIREMENT_AGE_ERROR = 'UPDATE_RETIREMENT_AGE_ERROR';
export const SET_INITIAL_STATE_FOR_RETIREMENT_AGE = 'SET_INITIAL_STATE_FOR_RETIREMENT_AGE';

export const updateRetirementAgeData = (data: any) => ({
  type: UPDATE_RETIREMENT_AGE_DATA,
  payload: data,
});

export const modelRetirementAgeScenario = () => ({
  type: MODEL_RETIREMENT_AGE_SCENARIO,
});

export const updateRetirementAgeError = (data: Array<Record<string, any>>) => ({
  type: UPDATE_RETIREMENT_AGE_ERROR,
  payload: data,
});

export const setInitialStateForRetirementAge = (data: any) => ({
  type: SET_INITIAL_STATE_FOR_RETIREMENT_AGE,
  payload: data,
});
